import { Divider, Stack } from "@mui/material";
import FillingModalBody from "../../../Modals/FillingModal/FillingModalBody";
import React, { memo } from "react";
import { useStoreSystem } from "../../../../store";
import shallow from "zustand/shallow";
import styles from "./ItemsPanel.module.scss";
import DefaultIcon from "../../../../assets/icons/default_icon.jpg";

export const ItemsPanel = memo(() => {
    const { setTireRacksModal, constructions } = useStoreSystem(
        (state) => ({
            setTireRacksModal: state.setTireRacksModal,
            constructions: state.constructions,
        }),
        shallow
    );

    return (
        <Stack direction={"row"} spacing={5}>
            <FillingModalBody isBottom />
            <Divider orientation="vertical" variant="middle" flexItem />
            <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-around">
                {Object.entries(constructions).map(([category, catalog]) => {
                    return (
                        <button
                            key={catalog.NAME}
                            onClick={() => {
                                setTireRacksModal(true, category);
                            }}
                            className={styles.decorCategory}
                        >
                            <img src={catalog.IMG || DefaultIcon} alt={catalog.NAME} />
                            <span>{catalog.NAME}</span>
                        </button>
                    );
                })}
            </Stack>
        </Stack>
    );
});
